import React from 'react';
import packageJson from '../../../../package.json';
import styles from './Layout.module.scss';

export const Layout = (props: { children: React.ReactNode }) => {
    return (
        <main className={styles.mainWrap}>
            {props.children}
            <p className={styles.version}>v{packageJson.version}</p>
        </main>
    );
};
